import { render, staticRenderFns } from "./prize-competition-form.vue?vue&type=template&id=424fef26&scoped=true&lang=pug"
import script from "./prize-competition-form.vue?vue&type=script&setup=true&lang=js"
export * from "./prize-competition-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./prize-competition-form.vue?vue&type=style&index=0&id=424fef26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424fef26",
  null
  
)

export default component.exports